import React, { useEffect, useState } from 'react';
import { getColorAndSanitizedString, getTextColorForBackground } from '../Utils/colorUtils';


function TimeTableInput({ data, editable = false, dataLeft, dataRight, dataTop, dataBottom, timeUnitIndex, dayIndex, studentId, onChange = (oldValue, newValue, timeUnitIndex, dayIndex, studentId) => {} }) {
  const [value, setValue] = useState(data);
  const [prevValue, setPrevValue] = useState(data);
  const [isEditing, setIsEditing] = useState(false);

  // get color for this cell (utility now returns only the color string or null)
  const bgColor = getColorAndSanitizedString((value ?? '').toString());

  // helper to get color for neighbors
  const getColorFor = (v) => getColorAndSanitizedString((v ?? '').toString());
  const colorLeft = getColorFor(dataLeft);
  const colorRight = getColorFor(dataRight);
  const colorTop = getColorFor(dataTop);
  const colorBottom = getColorFor(dataBottom);

  const isSameColor = (nbrColor) => {
    if (!nbrColor || !bgColor) return false;
    return nbrColor === bgColor;
  }

  // Only apply corner radius if both horizontal and vertical neighbors are different (based on color)
  // Only update borders/margins if not editing
  const borderTopLeftRadius = !isEditing && !isSameColor(colorLeft) && !isSameColor(colorTop) ? '8px' : '0px';
  const borderTopRightRadius = !isEditing && !isSameColor(colorRight) && !isSameColor(colorTop) ? '8px' : '0px';
  const borderBottomLeftRadius = !isEditing && !isSameColor(colorLeft) && !isSameColor(colorBottom) ? '8px' : '0px';
  const borderBottomRightRadius = !isEditing && !isSameColor(colorRight) && !isSameColor(colorBottom) ? '8px' : '0px';

  // Only update padding if not editing
  const paddingLeft = !isEditing && isSameColor(colorLeft) ? '0px' : '2px';
  const paddingRight = !isEditing && isSameColor(colorRight) ? '0px' : '2px';
  const paddingTop = !isEditing && isSameColor(colorTop) ? '0px' : '4px';
  const paddingBottom = !isEditing && isSameColor(colorBottom) ? '0px' : '4px';

  // Update local state when props change (either this cell or any neighbors)
  useEffect(() => {
    setValue(data);
    setPrevValue(data);
  }, [data, dataLeft, dataRight, dataTop, dataBottom]);

  return (
    <div 
      className="absolute inset-0"
      style={{
        paddingLeft,
        paddingRight,
        paddingTop,
        paddingBottom,
        borderTopLeftRadius,
        borderTopRightRadius,
        borderBottomLeftRadius,
        borderBottomRightRadius,
        boxSizing: 'border-box',
        color: getTextColorForBackground(bgColor || '#e5e7eb'), // gray fallback when no color
      }}
    >

      <input
        type="text"
        className="w-full h-full border-none font-semibold text-center focus:outline-none text-xl py-4"
        style={{
          backgroundColor: bgColor || '#e5e7eb', // gray fallback when no color
          borderRadius: 'inherit', // Ensure input inherits parent border radius
        }}
        disabled={!editable}
        value={value}
        title={value || ''}
        onFocus={() => setIsEditing(true)}
        onBlur={() => {
          setIsEditing(false);
          if (prevValue !== value) {
            onChange(prevValue, value, timeUnitIndex, dayIndex, studentId);
            setPrevValue(value);
          }
        }}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
    </div>
      );
}


export default TimeTableInput;